// extracted by mini-css-extract-plugin
module.exports = {"superchargeSolarSection":"SuperchargeSolarSection_superchargeSolarSection__yq_vM"};